export default __webpack_public_path__ + "static/media/26362 - DaNameKai.0c91bbad.jpeg";